define("shared/utils/segment/system-labels", ["exports", "@ember/utils", "later/utils/object-promise-proxy"], function (_exports, _utils, _objectPromiseProxy) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.systemLabelsFromPostMediaItems = _exports.systemLabelsFromGram = void 0;
  0; //eaimeta@70e063a35619d71f0,"@ember/utils",0,"later/utils/object-promise-proxy"eaimeta@70e063a35619d71f

  /**
   * @module Utils
   * @extends Utils
   *
   *
   * Grabs all of the system labels from a gram and converts it to a readable format for segment.
   *
   *
   * @method systemLabelsFromGram
   * @param {Object} gram The gram from which to pull system labels through related media items.
   * @returns {String} snake_case formatted string with labels seperated by commas. ex. "unsplash,repost"
   */
  const systemLabelsFromGram = gram => {
    const labels = gram.get('postMediaItems').map(pmi => {
      const items = _getSystemLabelsFromMediaItem(pmi.mediaItem);

      return (0, _utils.isEmpty)(items) ? 'null_value' : items;
    });
    return _format(labels);
  };
  /**
   * @method systemLabelsFromPostMediaItems
   * @param {Objects} postMediaItems The postMediaItems from which to pull system labels through related media items.
   * @returns {String} snake_case formatted string with labels seperated by commas. ex. "unsplash,repost"
   */


  _exports.systemLabelsFromGram = systemLabelsFromGram;

  const systemLabelsFromPostMediaItems = postMediaItems => {
    if (postMediaItems.ordering === 0) {
      const items = _getSystemLabelsFromMediaItem(postMediaItems.mediaItem);

      return (0, _utils.isEmpty)(items) ? 'null_value' : _format(items);
    }

    const labels = postMediaItems.map(pmi => {
      const items = _getSystemLabelsFromMediaItem(pmi.mediaItem);

      return (0, _utils.isEmpty)(items) ? 'null_value' : items;
    });
    return _format(labels);
  };

  _exports.systemLabelsFromPostMediaItems = systemLabelsFromPostMediaItems;

  const _format = labels => labels.flat().join(',').replace(/ /g, '_');

  const _getSystemLabelsFromMediaItem = async mediaItem => {
    const resolvedMediaItem = await (0, _objectPromiseProxy.default)(mediaItem);
    return resolvedMediaItem.labels.filter(label => label.isSystemLabel).map(label => label.canonicalTagName);
  };
});